<template>
  <footer class="app__footer footer">
    <div class="footer__options__wrapper">
      <div class="footer__options">
        <a href="/about" class="footer__option" @click.prevent="showAbout"
        >О программе</a
        >
        <a :href="licenseAgreementPath" target="_blank" class="footer__option"
        >Лицензия</a
        >
        <!-- <a href="#" class="footer__option" @click.prevent="showMessageToSupport">
          Сообщить об ошибке
        </a> -->
      </div>
      <div class="footer__options footer__sn">{{ techInfo }}</div>
    </div>
  </footer>
</template>

<script>
// import messageToSupport from '@@/shared/notifications/components/messageToSupport';
import AboutNormaCS from '@@/layout/AboutNormaCS';

export default {
  data: () => ({
    currentVersion: __VERSION__
  }),

  computed: {
    /** @returns {ApiAppInfo} */
    appInfo() {
      return this.$store.state.appInfo;
    },

    license() {
      return this.$store.state.auth.user.license;
    },

    techInfo() {
      let info = this.appInfo,
        text = `Ver. ${info.version}/v${this.currentVersion}, DB ${info.dbDate}`;

      if (this.license.serialNumber) {
        text += `, SN ${this.license.serialNumber}`;
      }
      return text;
    },

    licenseAgreementPath() {
      return `${location.protocol}//${
        location.host
      }${__BASE_URL__}NormaCS_4.x_License_Agreement_2020.pdf`;
    }
  },

  methods: {
    // TODO V2
    // showMessageToSupport: function(){
    //   this.$store.dispatch('notificationCreateModal', {
    //     title: 'Сообщить об ошибке',
    //     component: messageToSupport
    //   });
    // },
    showAbout: function() {
      this.$store.dispatch('notificationCreateModal', {component: AboutNormaCS});
    }
    //,
    // showToast: function(){
    //   this.$store.dispatch('notificationCreateToast', {
    //     text:
    //       'Этого сообщения здесь появляться не будет, по ссылке пользователь перейдет на страницу О программе. Сейчас же здесь работает пример того, как может выглядеть оповещение.',
    //     delay: 10000
    //   });
    //   setTimeout(()=>{
    //     this.$store.dispatch('notificationCreateToast', {
    //     text: 'И еще одна ошибка',
    //     type: 'error'
    //   });
    //   }, 2000);
    // }
  }
};
</script>
<style src="./footer.css" />
